export const contentVariants = {
    hidden: { y: 10 },
    visible: { y: 0, transition: { delay: 0.3 } },
};
